/* eslint max-len: 0 */
import avatarExperience from '../images/experience.png';
import avatarZillow from '../images/zillow.svg';
import avatarGoogle from '../images/google.svg';

export default (name, review, date, avatar, service) => {
  const vendorLogo = {
    experience: avatarExperience,
    zillow: avatarZillow,
    google: avatar ?? avatarGoogle,
  };

  const vendorLogoImg = vendorLogo[service];

  return `<div class="reviews__slide w-slide">
            <div class="reviews-slide__content-wrapper">
                <div class="reviews-slide__content">
                    <div class="reviews-slide__img-wrapper">
                        <div class="reviews-slide__img-white-circle">
                          <img src=${vendorLogoImg}
                            loading="lazy"
                            alt="avatar"
                            class="reviews-slide__img"/>
                          <img src="https://assets.website-files.com/62398b81b1a982d05618c759/6239b691fe05209d1a338e77_quote-icon.0f66101d.svg"
                            loading="lazy"
                            alt="quote"
                            class="reviews-slide__quote-img"/>
                        </div>
                    </div>
                    <div class="reviews___name">${name}</div>
                    <div class="reviews__text">${review}</div>
                    <div class="reviews__info">
                        <div class="reviews-info__item">
                            <div class="info-item__subtitle">Recommendation</div>
                            <div class="reviews-info__value">${date}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
};
